
import { Component, Inject, Vue, Watch } from "vue-property-decorator";
import { Container } from "inversify";
import { OrganizationStore } from "../../../stores/organization/OrganizationStore";
import LoadingOverlay from "../../../../../common/src/components/LoadingOverlay.vue";
import { handleError } from "../../../../../common/src/utility/errorUtils";
import { OrganizationItem } from "@gsx/common/src/types/http/dashboard/organization";
import { event } from "vue-gtag";
import { PaymentService } from "../../../../../landing/src/utility/payment/PaymentService";
import { NotificationStore } from "../../../../../common/src/stores/NotificationStore";
import { Api } from "../../../../../common/src/api/Api";
import { AuthStore } from "../../../../../common/src/stores/AuthStore";
import FlashNewsSocialFeed from "../../../molecules/flashNews/SocialFeed.vue";
import QuiltyInsightsSocialFeed from "../../../molecules/quiltyInsights/SocialFeed.vue";
import { QuiltyInsightsListStore } from "../../../stores/quiltyInsights/QuiltyInsightsListStore";
import GlobalCalendarCard from "../../user-dashboard/GlobalCalendarCard.vue";
@Component({
    components: {
        LoadingOverlay,
        FlashNewsSocialFeed,
        QuiltyInsightsSocialFeed,
        GlobalCalendarCard,
    },
})
export default class NewsEvents extends Vue {
    @Inject("container") readonly container!: Container;
    readonly organizationStore: OrganizationStore = this.container.get(OrganizationStore);
    readonly notificationStore: NotificationStore = this.container.get(NotificationStore);
    readonly api: Api = this.container.get(Api);
    readonly paymentService: PaymentService = this.container.get(PaymentService);
    readonly authStore: AuthStore = this.container.get(AuthStore);
    readonly quiltyInsightsListStore: QuiltyInsightsListStore =
        this.container.get(QuiltyInsightsListStore);

    get organizationId(): string {
        return this.$route.params.organization;
    }

    get organization(): OrganizationItem | null {
        return this.organizationStore.item;
    }

    @Watch("organizationId")
    load() {
        this.organizationStore
            .load(this.organizationId)
            .then(() => {
                if (this.organization) {
                    event("Organization", {
                        eventCategory: "Organization",
                        eventAction: "view",
                        eventLabel: this.organization.organizationName,
                    });
                }
            })
            .catch(handleError);

        this.quiltyInsightsListStore.load().catch(handleError);
    }
}
